import React from "react"
import classnames from "classnames"
import styles from "./ApplyButton.module.scss"
import windowService from "../../../services/WindowService"

export const ApplyButton = ({ onClick }) => (
  <button
    onClick={() => {
      onClick()
      windowService.animatedScrollTop()
    }}
    className={classnames("btn btn-dark", styles["apply-button"])}>
    Apply
  </button>
)
